// extracted by mini-css-extract-plugin
export default {"root":"Card__root--1ptj0","changeCard":"Card__changeCard--1F8fP"};